import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask, InputMaskChangeParams } from 'primereact/inputmask';

import { ModelOfBidding, ModelOfContrato } from 'src/database';

import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import LoadingScreen from '../../components/LoadingScreen';
import { useListContratosController, } from '../../controllers/Contrato/ListContratosController';
import { Toast } from 'primereact/toast'; 
import { PulseLoader } from 'react-spinners';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { dateToString } from 'src/utils/dateToString';
import { Tooltip } from 'primereact/tooltip';

interface InputMaskProps {
    label: string;
    mask: string;
    placeholder: string;
}

interface filteredProps {
    label: string;
    value?: string;
}

const ContratosList: React.FC = () => {
    const { getContratoListController, handleContratoListController } = useListContratosController();
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    
    if (getContratoListController.loading) {
        return <LoadingScreen />
    };

    const tableHeader = (
        <div className="table-header p-grid p-d-flex p-jc-between">
            <h5 className="p-m-0">Contratos</h5>
            <span className="p-input-icon-left p-search-bar">
                <i className="pi pi-search" />
                <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (Contrato: ModelOfContrato) => {
        return (
            
            <React.Fragment>
                <Tooltip target=".unity-editarcontrato-btn" content="Editar contrato" position="top" />
                <Tooltip target=".unity-excluircontrato-btn" content="Excluir contrato" position="top" />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2 unity-editarcontrato-btn" onClick={() => handleContratoListController.openEditDialog(Contrato)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger unity-excluircontrato-btn" onClick={() => handleContratoListController.openDeleteDialog(Contrato)} />
            </React.Fragment>
        );
    };

    const editContratoDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleContratoListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getContratoListController.formik.handleSubmit() }} />
        </React.Fragment>
    );



    const deleteContratoDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleContratoListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getContratoListController.selectedContrato && handleContratoListController.removeContrato(getContratoListController.selectedContrato)
                }}
            />
        </React.Fragment>
    );

    const leftContratoToolbar = () => {
        return (
            <Link to="/contratoForm">
                <Button label="Cadastrar contrato" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const HEADER_NUMERO = (rowData: ModelOfContrato) => {
        return (
            <React.Fragment>
                <span className="left-header">NUMERO</span>
                {rowData.NUMERO}
            </React.Fragment>
        );
    }

    const HEADER_DESCRICAO = (rowData: ModelOfContrato) => {
        return (
            <React.Fragment>
                <span className="left-header">DESCRICAO</span>
                {rowData.DESCRICAO}
            </React.Fragment>
        );
    }
    const HEADER_TAXAADM = (rowData: ModelOfContrato) => {
        return (
            <React.Fragment>
                <span className="left-header">TAXAADM</span>
                {rowData.TAXAADM}
            </React.Fragment>
        );
    }

    const HEADER_VALOR = (rowData: ModelOfContrato) => {
        return (
            <React.Fragment>
                <span className="left-header">VALOR</span>
                {rowData.VALOR != null
                    ? Number(rowData.VALOR).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    : '-'}
            </React.Fragment>
        );
    }

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });

      

        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {children}
            </div>
        )
    }

    const handleChangeCPFCNPJ = (e: InputMaskChangeParams) => {
        console.log("InputMaskChangeParams: ", e)
        console.log("InputMaskChangeParams: ", e.target)
        console.log("InputMaskChangeParams: ", e.target.value)
        console.log("InputMaskChangeParams: ", e.value)
        getContratoListController.formik.setFieldValue('CPF_CNPJ', e.target.value);
    };


    return (
        <div>
            <Toast ref={getContratoListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftContratoToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter} rowHover
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" autoLayout scrollable scrollHeight={'100%'}
                    value={getContratoListController.ContratosData}
                >
                    <Column field="NUMERO" header="NUMERO" body={HEADER_NUMERO}></Column>
                    <Column field="DESCRICAO" header="DESCRICAO" body={HEADER_DESCRICAO}></Column>
                    <Column field="TAXAADM" header="TAXAADM" body={HEADER_TAXAADM}></Column>
                    <Column field="VALOR" header="VALOR" body={HEADER_VALOR}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
               
            </div>


            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getContratoListController.editDialog}
                onHide={handleContratoListController.closeEditDialog}
                onShow={() => {
                    getContratoListController.formik.setValues(getContratoListController.selectedContrato);
                }}
                footer={editContratoDialogFooter}
                header={`Editar contrato ${getContratoListController.selectedContrato?.NUMERO}`}
                modal
            >
                {getContratoListController.loadingEdit ? <LoadingScreen color="#0388e5" /> : <></>}
                <div className="p-grid p-fluid">

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="nomeComp">NUMERO</label>
                        <InputText id="nomeComp"
                            {...getContratoListController.formik.getFieldProps('NUMERO')}
                            onChange={getContratoListController.formik.handleChange('NUMERO')}
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="valorEdit">VALOR DO CONTRATO</label>
                        <InputNumber
                            id="valorEdit"
                            value={getContratoListController.formik.values.VALOR ?? 0}
                            onValueChange={(e) => getContratoListController.formik.setFieldValue('VALOR', e.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="taxaAdmEdit">TAXA ADM (%)</label>
                        <InputText id="taxaAdmEdit"
                            {...getContratoListController.formik.getFieldProps('TAXAADM')}
                            onChange={getContratoListController.formik.handleChange('TAXAADM')}
                        />
                    </div>

                    <div className="p-field p-col-12">
                        <label htmlFor="descricaoEdit">DESCRIÇÃO</label>
                        <InputText id="descricaoEdit"
                            {...getContratoListController.formik.getFieldProps('DESCRICAO')}
                            onChange={getContratoListController.formik.handleChange('DESCRICAO')}
                        />
                    </div>

                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getContratoListController.deleteDialog}
                onHide={handleContratoListController.closeDeleteDialog}
                footer={deleteContratoDialogFooter}
                header="Remover contrato"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getContratoListController.selectedContrato && <span>Você tem certeza que deseja remover <b>{getContratoListController.selectedContrato.NUMERO}</b>?</span>}
                </div>
            </Dialog>        
        </div>

    );
};

export default ContratosList;